import { Component, type ErrorInfo, type ReactNode } from 'react'
import { GenericErrorPage } from '@/components/GenericErrorPage'

interface Props {
  children: ReactNode
  fallback?: ReactNode
}

interface State {
  hasError: boolean
}

export class ErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false }

  static getDerivedStateFromError(): State {
    return { hasError: true }
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error('ErrorBoundary caught:', error, info)
    // Send to error reporting service
  }

  render() {
    if (this.state.hasError) {
      return this.props.fallback ?? <GenericErrorPage />
    }
    return this.props.children
  }
}
